export interface Environment {
  ENVIRONMENT: string;
  APP_BASE_URL: string;
  APP_SSO_BASE_URL: string;
  APP_REDIRECT_URI: string;
  APP_GOOGLE_OAUTH_CLIENT_ID: string;
  APP_GOOGLE_OAUTH_CLIENT_SECRET: string;
  APP_STRIPE_PK: string;
  [key: string]: string;
}

let isFetching = false;

const wait = (ms = 100): Promise<boolean> =>
  new Promise((resolve) => {
    const int = setInterval(() => {
      resolve(true);
      clearInterval(int);
    }, ms);
  });

const decode = (env: Record<string, string>): Environment => {
  return Object.keys(env).reduce(
    (prev, curr) => {
      prev[curr] = atob(env[curr]);

      return prev;
    },
    {} as Record<string, string>,
  ) as Environment;
};

export const getEnvironment = async (): Promise<Environment> => {
  const cached = sessionStorage.getItem('environment');

  if (cached) {
    return decode(JSON.parse(cached));
  }

  if (isFetching) {
    await wait();
    return getEnvironment();
  }

  isFetching = true;
  const response = await fetch('/api/env');
  const env = await response.json();
  sessionStorage.setItem('environment', JSON.stringify(env));
  isFetching = false;

  return decode(env);
};
